var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avatar-container"},[_c('md-avatar',{staticClass:"dropdown-toggle",class:`md-${_vm.size}`},[_c('img',{staticClass:"header-img",attrs:{"src":"/img/favicon2.png","alt":"Swampum","width":_vm.chooseImgSize,"height":_vm.chooseImgSize}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }